import { FAQPageJsonLd } from 'next-seo';

import { SITE_TITLE, SITE_URL } from '@/utils/constants';

import Accordions from '../faqs/accordian';
import { generateDynamicFAQ } from '../utility';

const FAQValet = (props: any) => {
  const faqTitle = props?.title;
  const faqData = props?.data;
  const brand = SITE_TITLE;
  const brandUrl = props?.hostUrl ? `https://${props?.hostUrl}` : SITE_URL;

  const isFaqInfo = !(props?.data && props?.data[0]?.attributes?.Title);
  const faqStructuredData =
    faqData && generateDynamicFAQ(faqData, isFaqInfo, brand, brandUrl);

  return (
    <>
      <FAQPageJsonLd mainEntity={faqStructuredData} />

      {faqData && faqData.length && (
        <section className="FAQ-section" id="faq">
          <div className="container">
            <h2 className="section-heading">{faqTitle}</h2>
            {faqData &&
              faqData.length &&
              faqData.map((item: any, index: any) => {
                const title = item?.Title
                  ? item.Title
                  : item?.attributes?.Title;
                const brandData = item?.attributes?.Brands;
                const description = item?.Description
                  ? item.Description
                  : item?.attributes?.Content;
                return (
                  <div key={index}>
                    <Accordions
                      title={title}
                      content={description}
                      index={index}
                      randData={brandData}
                      className="sv-accordion mb-4"
                      siteUrl={props?.hostUrl}
                    />
                  </div>
                );
              })}
          </div>
        </section>
      )}
    </>
  );
};

export default FAQValet;
